
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class BrandMasterGrid extends Serenity.EntityGrid<BrandMasterRow, any> {
        protected getColumnsKey() { return 'OMS.BrandMaster'; }
        protected getDialogType() { return BrandMasterDialog; }
        protected getIdProperty() { return BrandMasterRow.idProperty; }
        protected getLocalTextPrefix() { return BrandMasterRow.localTextPrefix; }
        protected getService() { return BrandMasterService.baseUrl; }
        protected getInsertPermission() { return BrandMasterRow.insertPermission; }
        protected getUpdatePermission() { return BrandMasterRow.updatePermission; }
        protected getDeletePermission() { return BrandMasterRow.deletePermission; }
        protected useViewMode() { return true; }


        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); 
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}